import React from "react";
import CheckOutlined from "@ant-design/icons/CheckOutlined";

export const Check = () => <CheckOutlined style={{ color: "green" }} />;
